
export class SFTPUserDTO{
    public id!: number;
    public customerId!: number;
    public sftpUsername!: string;
    public sftpPassword!: string;
    public description!: string;
    public enabled!: boolean;
    public added!: string;
    public edited!: string;
}